import React from 'react';
import ReactDOM from 'react-dom/client';

import DataProvider from './context/DataProvider/DataProvider';
import { LanguageProvider } from './context/LanguageProvider/LanguageProvider';
import { AuthProvider } from './context/AuthProvider/AuthProvider';
import { AdminDataProvider } from './context/AdminDataProvider/AdminDataProvider';
import { SiteSettingsProvider } from './context/SiteSettingsProvider/SiteSettingsProvider';

import App from './App';

import './assets/scss/style.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DataProvider>
      <LanguageProvider>
        <AuthProvider>
          <SiteSettingsProvider>
            <AdminDataProvider>
              <App />
            </AdminDataProvider>
          </SiteSettingsProvider>
        </AuthProvider>
      </LanguageProvider>
    </DataProvider>
  </React.StrictMode>,
);
